"use client";

import { useTranslations } from "next-intl";
import { BackButtonHeader, BlurImage, PageWrapper } from "@/components/core";

const POINT_IDS = [
  "point1",
  "point2",
  "point3",
  "point4",
  "point5",
  "point6",
  "point7",
] as const;

const AboutUsPage = () => {
  const t = useTranslations("about");
  return (
    <PageWrapper
      outsideChildren={
        <BackButtonHeader
          title={t("title")}
          className="pt-5 pb-4 px-4"
          showBorder
          borderColor="light"
        />
      }
    >
      <BlurImage
        wrapperClassName="w-full"
        className="rounded-md w-full"
        src={"/images/ui/about-us.webp"}
        width={388}
        height={190}
        loading="lazy"
        alt="about-us"
      />

      <p className="text-sm mb-6 text-pretty leading-8">
        {t("para1")}
        <br />
        {t("para2")}
        <br /> {t("para3")}
        <br /> {t("para4")}
      </p>

      <div className="bg-bg-secondary border-r-3 border-stroke-light rounded-lg p-5 mx-4">
        <h4 className="text-base font-semibold mb-3">{t("snapshotTitle")}</h4>
        <ul className="list-[square] list-inside text-sm space-y-2">
          {POINT_IDS.map((id) => (
            <li key={id}>{t(id)}</li>
          ))}
        </ul>
      </div>
    </PageWrapper>
  );
};

export default AboutUsPage;
